import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'

// Vant 按需引入配置已完成
// 在组件中使用示例：
// import { Button, Cell, CellGroup } from 'vant'
// Vue.use(Button).use(Cell).use(CellGroup)
// 或者在组件中直接使用：<van-button>按钮</van-button>

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
